export const PATHS = {
  users: {
    index: '/usuarios',
    new: '/usuarios/novo',
    view: (id: string) => `/usuarios/visualizar/${id}`,
    edit: (id: string) => `/usuarios/editar/${id}`
  },
  inspections: {
    index: '/vistorias',
    new: '/vistorias/novo',
    view: (id: string, aba?: string) =>
      `/vistorias/visualizar/${id}${aba ? `/${aba}` : ''}`,
    edit: (id: string, aba?: string) =>
      `/vistorias/editar/${id}${aba ? `/${aba}` : ''}`,
    evaluate: (id: string, aba?: string) =>
      `/vistorias/avaliar/${id}${aba ? `/${aba}` : ''}`,
    start: (id: string, aba?: string) =>
      `/vistorias/iniciar/${id}${aba ? `/${aba}` : ''}`
  },
  precification: {
    index: '/precificacao',
    new: '/precificacao/novo',
    view: (id: string, aba?: string) =>
      `/precificacao/visualizar/${id}${aba ? `/${aba}` : ''}`,
    edit: (id: string, aba?: string) =>
      `/precificacao/editar/${id}${aba ? `/${aba}` : ''}`
  },
  refund: {
    index: '/reembolso',
    new: '/reembolso/novo',
    edit: (id: string) => `/reembolso/editar/${id}`
  },
  preparation: {
    index: '/preparacao',
    new: '/preparacao/novo',
    view: (id: string) => `/preparacao/visualizar/${id}`,
    edit: (id: string) => `/preparacao/editar/${id}`,
    complete: (id: string) => `/preparacao/concluir/${id}`,
    summary: (id: string) => `/preparacao/resumo/${id}`
  },
  parametrization: {
    brands: {
      index: '/parametrizacao-marca',
      new: '/parametrizacao-marca/novo',
      view: (id: string) => `/parametrizacao-marca/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-marca/editar/${id}`
    },
    category: {
      index: '/parametrizacao-categorias',
      new: '/parametrizacao-categorias/novo',
      view: (id: string) => `/parametrizacao-categorias/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-categorias/editar/${id}`
    },
    sla: {
      index: '/parametrizacao-sla',
      new: '/parametrizacao-sla/novo',
      view: (id: string) => `/parametrizacao-sla/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-sla/editar/${id}`
    },
    breakdowns: {
      index: '/parametrizacao-avarias',
      new: '/parametrizacao-avarias/novo',
      view: (id: string) => `/parametrizacao-avarias/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-avarias/editar/${id}`
    },
    providers: {
      list: '/parametrizacao-prestadores',
      new: '/parametrizacao-prestadores/novo',
      view: (id: string) => `/parametrizacao-prestadores/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-prestadores/editar/${id}`
    },
    serialItem: {
      list: '/parametrizacao-itens-opcoes',
      new: '/parametrizacao-itens-opcoes/novo',
      view: (id: string) => `/parametrizacao-itens-opcoes/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-itens-opcoes/editar/${id}`
    },
    accessories: {
      list: '/parametrizacao-acessorios',
      new: '/parametrizacao-acessorios/novo',
      view: (id: string) => `/parametrizacao-acessorios/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-acessorios/editar/${id}`
    },
    inspection: {
      index: '/parametrizacao-vistorias'
    },
    appraisalCompany: {
      list: '/parametrizacao-empresa-avaliadora',
      new: '/parametrizacao-empresa-avaliadora/novo',
      view: (id: string) =>
        `/parametrizacao-empresa-avaliadora/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-empresa-avaliadora/editar/${id}`
    },
    inspectionCategories: {
      index: '/parametrizacao-categorias-vistoria',
      new: '/parametrizacao-categorias-vistoria/novo',
      view: (id: string) =>
        `/parametrizacao-categorias-vistoria/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-categorias-vistoria/editar/${id}`
    },
    products: {
      list: '/parametrizacao-produtos',
      new: '/parametrizacao-produtos/novo',
      view: (id: string) => `/parametrizacao-produtos/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-produtos/editar/${id}`
    },
    services: {
      list: '/parametrizacao-servicos',
      new: '/parametrizacao-servicos/novo',
      view: (id: string) => `/parametrizacao-servicos/visualizar/${id}`,
      edit: (id: string) => `/parametrizacao-servicos/editar/${id}`
    },
    evaluationType: {
      index: '/parametrizacao-tipos-avaliacao',
      new: '/parametrizacao-tipos-avaliacao/novo',
      edit: (id: string) => `/parametrizacao-tipos-avaliacao/editar/${id}`
    },
    inspectionPhotos: {
      index: '/parametrizacao-fotos-vistoria',
      new: '/parametrizacao-fotos-vistoria/novo',
      edit: (id: string) => `/parametrizacao-fotos-vistoria/editar/${id}`
    },
    photoSections: {
      index: '/parametrizacao-secao-fotos',
      new: '/parametrizacao-secao-fotos/novo',
      edit: (id: string) => `/parametrizacao-secao-fotos/editar/${id}`
    },
    photoFlow: {
      index: '/parametrizacao-fluxo-fotos',
      new: '/parametrizacao-fluxo-fotos/novo',
      edit: (id: string) => `/parametrizacao-fluxo-fotos/editar/${id}`
    },
    checklist: {
      index: '/parametrizacao-checklists',
      new: '/checklist/novo',
      edit: (id: string) => `/checklist/editar/${id}`
    }
  },
  currentActiveLocation: {
    list: '/local-atual-ativo',
    history: (id: string) => `/local-atual-ativo/historico/${id}`
  },
  integrations: {
    index: '/integracoes'
  },
  files: {
    index: '/arquivos'
  }
} as const
